var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ContentCard',[_c('div',{staticClass:"manage"},[(_vm.accountName)?_c('DirectDebitOverview',{attrs:{"accountname":_vm.accountName,"browse":""}}):_vm._e()],1)])}
var staticRenderFns = []

export { render, staticRenderFns }